import Swiper from 'swiper';
import { Pagination, Navigation } from 'swiper';

const setMapSlider = () => {
  const targetSliders = document.querySelectorAll('.js-map-slider');

  targetSliders.forEach((Slider) => {
    const swiper = new Swiper(Slider, {
      modules: [Pagination, Navigation],
      slidesPerView: 1,
      spaceBetween: 30,
      speed: 500,
      centeredSlides: true,
      pagination: {
        el: Slider.closest('.map-slider').querySelector('.swiper-pagination'),
        clickable: true,
      },
      navigation: {
        nextEl: Slider.closest('.map-slider').querySelector('.swiper-button-next'),
        prevEl: Slider.closest('.map-slider').querySelector('.swiper-button-prev'),
      },
    });
  });
};

export default setMapSlider;
